export const generateForm24QHtml = (formData) => {
  const {
    financialYear,
    quarter,
    tan,
    pan,
    verifierName,
    typeOfDeductor,
    address,
    responsiblePersonName,
    responsiblePersonDesignation,
    responsiblePersonPan,
    challans,
    deductees,
    totalTdsDeposited
  } = formData

  const assessmentYear = financialYear
    ? `${parseInt(financialYear.split('-')[0]) + 1}-${parseInt(financialYear.split('-')[1]) + 1}`
    : ''

  // Calculate the total TDS amount from the deductees list
  const totalDeducteeAmount = deductees
    .reduce((sum, d) => sum + (parseFloat(d.tdsDeducted) || 0), 0)
    .toFixed(2)

  return `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Form 24Q</title>
        <style>
          body { font-family: "Helvetica", "Arial", sans-serif; font-size: 9px; margin: 0; padding: 0; color: #000; line-height: 1.3; }
          .container { width: 90%; max-width: 90%; margin: 0 auto; padding: 20px; }
          
          /* Table Styles */
          table { width: 100%; border-collapse: collapse; margin-bottom: 20px; page-break-inside: auto; table-layout: fixed; }
          tr { page-break-inside: avoid; page-break-after: auto;padding: 10px; }
          th, td { 
            border: 1px solid #000; 
            padding: 3px 4px; 
            text-align: left; 
            vertical-align: middle;
            word-wrap: break-word; /* Prevent overflow */
          }
          
          /* Headers & Utility */
          .center { text-align: center; }
          .right { text-align: right; }
          .bold { font-weight: bold; }
          .header { text-align: center; margin-bottom: 20px; }
          .title-text { font-size: 14px; font-weight: bold; margin-bottom: 5px; } 
          .subtitle-text { font-size: 10px; font-style: italic; margin-bottom: 10px; }
          
          /* Sections */
          .section-row { background-color: #f0f0f0; font-weight: bold; }
          .w-50 { width: 50%; }
          .val-cell { font-weight: bold; }
          
          /* Section 1 Specifics */
          .section-1-table td { vertical-align: top; }
  
          /* Annexures */
          .annexure-title { text-align: center; font-weight: bold; margin-top: 15px; text-decoration: underline; font-size: 12px; }
          .page-break { page-break-before: always; }
        </style>
      </head>
      <body>
        <div class="container">
        
          <!-- MAIN FORM HEADER -->
          <div class="header">
            <div class="title-text">Form No. 24Q</div>
            <div class="subtitle-text">(See section 192 and rule 31A)</div>
            <div style="margin-top: 5px;">
              Quarterly statement of deduction of tax under sub section (3) of section 200 of the Income tax Act, 1961 in respect of Salary<br>
              for the quarter ended <strong>${quarter}</strong> (${financialYear})
            </div>
          </div>

          <!-- SECTION 1 -->
          <!-- SECTION 1 -->
          <table class="section-1-table">
            <colgroup>
               <col style="width: 25%;">
               <col style="width: 25%;">
               <col style="width: 25%;">
               <col style="width: 25%;">
            </colgroup>
            <tr>
              <td style="vertical-align: top;">
                <div style="margin-bottom: 4px;"><strong>1. (a) Tax Deduction Account No.</strong></div>
                <div style="margin-bottom: 4px;">&nbsp;&nbsp;&nbsp;<strong>(b) Permanent Account No.</strong></div>
                <div>&nbsp;&nbsp;&nbsp;<strong>(c) Financial year</strong></div>
              </td>
              <td style="vertical-align: top;">
                 <div style="margin-bottom: 4px;">${tan}</div>
                 <div style="margin-bottom: 4px;">${pan}</div>
                 <div>${financialYear}</div>
              </td>
              <td style="vertical-align: top;">
                <div style="margin-bottom: 4px;"><strong>(d) Assessment year</strong></div>
                <div style="margin-bottom: 4px;"><strong>(e) Has any statement been filed earlier for this quarter?</strong></div>
                <div><strong>(f) If answer to (e) is 'Yes', then Provisional Receipt no.</strong></div>
              </td>
               <td style="vertical-align: top;">
                 <div style="margin-bottom: 4px;">${assessmentYear}</div>
                 <div style="margin-bottom: 4px;">No</div>
                 <div>-</div>
              </td>
            </tr>
          </table>

          <!-- SECTION 2 -->
          <table>
             <colgroup>
               <col style="width: 30%;">
               <col style="width: 70%;">
            </colgroup>
            <tr class="section-row">
              <td colspan="2">2. Particulars of the deductor (employer)</td>
            </tr>
            <tr>
              <td>(a) Name</td>
              <td class="val-cell">${verifierName}</td>
            </tr>
            <tr>
              <td>(b) Type of deductor</td>
              <td class="val-cell">${typeOfDeductor}</td>
            </tr>
            <tr>
              <td>(c) Branch / division (if any)</td>
              <td class="val-cell"></td>
            </tr>
            <tr>
              <td>(d) Address (Flat No., Premises, Road, Area, Town, State, Pin, Email)</td>
              <td class="val-cell">
                ${address} <br/>
                Email: - | Tel: -
              </td>
            </tr>
          </table>

          <!-- SECTION 3 -->
           <table>
             <colgroup>
               <col style="width: 30%;">
               <col style="width: 70%;">
            </colgroup>
            <tr class="section-row">
              <td colspan="2">3. Particulars of the person responsible for deduction of tax</td>
            </tr>
            <tr>
              <td>(a) Name</td>
              <td class="val-cell">${responsiblePersonName}</td>
            </tr>
            <tr>
               <td>(b) Address (Flat No., Premises, Road, Area, Town, State, Pin, Email)</td>
                <td class="val-cell">	
                  - <br/>
                  Email: - | Tel: -
               </td>
            </tr>
          </table>

          <!-- SECTION 4 -->
          <table style="font-size: 8px;">
             <colgroup>
              <col style="width: 5%;">
              <col style="width: 9%;"> 
              <col style="width: 9%;">
              <col style="width: 9%;">
              <col style="width: 9%;">
              <col style="width: 9%;">
              <col style="width: 10%;"> 
              <col style="width: 10%;"> 
              <col style="width: 8%;">  
              <col style="width: 10%;"> 
              <col style="width: 12%;"> 
            </colgroup>
            <thead>
               <tr class="section-row">
                <td colspan="11">4. Details of tax deducted and paid to the credit of Central Government :</td>
              </tr>
              <tr class="center" style="background-color: #f9f9f9;">
                <th>Sr. No.</th>
                <th>TDS<br>(Rs.)</th>
                <th>Surcharge<br>(Rs.)</th>
                <th>Edu. Cess<br>(Rs.)</th>
                <th>Interest<br>(Rs.)</th>
                <th>Others<br>(Rs.)</th>
                <th>Total<br>(302+..+306)</th>
                <th>Cheque/ DD No.</th>
                <th>BSR code</th>
                <th>Date of Deposit</th>
                <th>Challan Serial No.</th>
              </tr>
              <tr class="center" style="font-size: 8px;">
                <td>(301)</td>
                <td>(302)</td>
                <td>(303)</td>
                <td>(304)</td>
                <td>(305)</td>
                <td>(306)</td>
                <td>(307)</td>
                <td>(308)</td>
                <td>(309)</td>
                <td>(310)</td>
                <td>(311)</td>
              </tr>
            </thead>
            <tbody>
              ${challans
                .map(
                  (c, i) => `
                <tr>
                  <td class="center">${i + 1}</td>
                  <td class="right">${c.tds}</td>
                  <td class="right">${c.surcharge}</td>
                  <td class="right">${c.educationCess}</td>
                  <td class="right">${c.interest}</td>
                  <td class="right">${c.others}</td>
                  <td class="right">${c.amount}</td>
                  <td class="center">-</td>
                  <td class="center">${c.bsr || '-'}</td>
                  <td class="center">${c.date}</td>
                  <td class="center">${c.serialNo}</td>
                </tr>
              `
                )
                .join('')}
               <!-- Fillers -->
               ${
                 challans.length === 0
                   ? `
                 <tr>
                  <td class="center">1</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
                 <tr>
                  <td class="center">2</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
                 <tr>
                  <td class="center">3</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
               `
                   : ''
               }
               <tr>
                <td colspan="6" class="right bold">Total</td>
                <td class="right bold">${totalTdsDeposited}</td>
                <td colspan="4"></td>
               </tr>
            </tbody>
          </table>

          <!-- SECTION 5 -->
           <div style="display: flex; margin-bottom: 20px;">
            <div style="width: 20px; font-weight:bold;">5</div>
            <div style="flex: 1;">Details of salary paid and tax deducted thereon from the employees<br><br>(Enclose annexures I,II and III)</div>
          </div>

          <!-- VERIFICATION -->
          <div class="header bold">VERIFICATION</div>
          <p>
            I, <u>${responsiblePersonName}</u>, hereby certify that all the particulars furnished above are correct and complete.
          </p>
          <br>
          <table style="border: none;">
            <tr>
              <td style="border: none; width: 50%;">Place: __________________</td>
              <td style="border: none; width: 50%;">Signature of person responsible for deducting tax at source __________________</td>
            </tr>
            <tr>
              <td style="border: none;">Date: __________________</td>
              <td style="border: none;">Name and designation of person responsible for deducting tax at source <br><strong>${responsiblePersonName} (${responsiblePersonDesignation})</strong></td>
            </tr>
          </table>

          <!-- NOTES -->
          <div style="font-size: 9px; margin-top: 20px;">
            Note :- (1) Indicate the type of deductor "Government"/"Others"<br>
            (2) Government deductors to give particulars of transfer vouchers; other deductors to give particulars of challan no. regarding deposit into bank.<br>
            (3) Column is relevant only for Government deductors.<br>
            (4) Salary includes wages, annuity, pension, gratuity, fees, commission, bonus, repayment of amount deposited under the Additional Emoluments (Compulsory Deposit) Act, 1974, or profits in lieu of or in addition to salary or wages, including payments made at or in connection with termination of employment advance of salary or any other sums chargeable to income-tax under the head 'Salaries'.<br>
            (5) Where an employer deducts from the emoluments paid to an employee or pays on his behalf any contributions of that employee to any approved superannuation fund, all such deductions or payments should be included in the statements.<br>
            (6) Please record on every page the totals of each of the columns.
          </div>

          <!-- ANNEXURE I -->
          <div class="page-break"></div>
          <div class="annexure-title">Annexure I - Deductee wise break-up of TDS</div>
          <div class="center" style="font-style: italic; font-size: 10px; margin-bottom: 10px;">(Please use separate Annexure for each line - item in the table at S.No. 04 of main Form 24Q)</div>
          
          <p>Details of salary paid and tax deducted thereon from the employees</p>
          
          <!-- Loop through Challans to create per-challan breakdown if we have that level of data. 
               Since the current data model separates challans and deductees, we will list deductees generally or mapped if possible.
               For this sample generator, we will create one table for all deductees, as if they belong to the main challans. -->

          <table style="border: 2px solid black;">
             <tr>
               <td width="20%">BSR code of the branch where tax is deposited</td>
               <td width="30%"></td>
               <td width="20%">Name of Employer</td>
               <td width="30%">${verifierName}</td>
             </tr>
             <tr>
               <td>Date on which tax deposited (dd-mm-yyyy)</td>
               <td></td>
               <td></td>
               <td></td>
             </tr>
             <tr>
               <td>Challan Serial No.</td>
               <td></td>
               <td></td>
               <td></td>
             </tr>
              <tr>
               <td>Section under which payment made</td>
               <td>92B</td>
               <td>TAN</td>
               <td>${tan}</td>
             </tr>
             <tr>
               <td>Total TDS to be allocated among deductees as in the vertical total of col. 323</td>
               <td colspan="3">${totalDeducteeAmount}</td>
             </tr>
              <tr>
               <td>Interest</td>
               <td colspan="3"></td>
             </tr>
              <tr>
               <td>Others</td>
               <td colspan="3"></td>
             </tr>
             <tr>
               <td>Total of the above</td>
               <td colspan="3"></td>
             </tr>
          </table>

          <table>
            <thead>
              <tr class="center">
                <th>Sr. No.</th>
                <th>Employee reference no. provided by employer</th>
                <th>PAN of the employee</th>
                <th>Name of the employee</th>
                <th>Date of payment / credit</th>
                <th>Taxable amount on which tax deducted Rs.</th>
                <th>TDS Rs.</th>
                <th>Surcharge Rs.</th>
                <th>Educational Cess Rs.</th>
                <th>Total Tax Deducted (319+320+321) Rs.</th>
                <th>Total Tax deposited Rs.</th>
                <th>Date of deduction</th>
                <th>Date of Deposit</th>
                <th>Reason for non-deduction / lower deduction*</th>
              </tr>
              <tr class="center" style="font-size: 9px;">
                <td>(313)</td>
                <td>(314)</td>
                <td>(315)</td>
                <td>(316)</td>
                <td>(317)</td>
                <td>(318)</td>
                <td>(319)</td>
                <td>(320)</td>
                <td>(321)</td>
                <td>(322)</td>
                <td>(323)</td>
                <td>(324)</td>
                <td>(325)</td>
                <td>(326)</td>
              </tr>
            </thead>
            <tbody>
              ${deductees
                .map(
                  (d, i) => `
                <tr>
                  <td class="center">${i + 1}</td>
                  <td>${d.employeeId || ''}</td>
                  <td class="center">${d.pan}</td>
                  <td>${d.name}</td>
                  <td class="center">${d.paymentDate}</td>
                  <td class="right">${d.totalSalary}</td>
                  <td class="right">${d.tdsDeducted}</td>
                  <td class="right">0</td>
                  <td class="right">0</td>
                  <td class="right">${d.tdsDeducted}</td>
                  <td class="right">${d.tdsDeducted}</td>
                  <td class="center">${d.paymentDate}</td>
                  <td class="center">${
                    d.paymentDate
                  }</td> <!-- Assuming deposit same as payment/filing for sample -->
                  <td></td>
                </tr>
              `
                )
                .join('')}
               <!-- Add empty rows if needed to look like the form -->
               ${
                 deductees.length === 0
                   ? `
                 <tr>
                  <td class="center">1</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
                 <tr>
                  <td class="center">2</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
                 <tr>
                  <td class="center">3</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
                 <tr>
                  <td class="center">4</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
                 <tr>
                  <td class="center">5</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
               `
                   : ''
               }
              <tr>
                <td colspan="6" class="right bold">Total</td>
                <td class="right bold">${totalDeducteeAmount}</td> <!-- Simplified Total -->
                <td></td>
                <td></td>
                <td class="right bold">${totalDeducteeAmount}</td>
                <td class="right bold">${totalDeducteeAmount}</td>
                <td colspan="3"></td>
              </tr>
            </tbody>
          </table>
          
          </table>

          <!-- SECTION 5 -->
           <div style="display: flex; margin-bottom: 20px; margin-top: 20px;">
            <div style="width: 20px; font-weight:bold;">5</div>
            <div style="flex: 1;">Details of salary paid and tax deducted thereon from the employees<br><br>(Enclose annexures I,II and III)</div>
          </div>

          <!-- VERIFICATION -->
          <div class="header bold">VERIFICATION</div>
          <p>
            I, <u>${responsiblePersonName}</u>, hereby certify that all the particulars furnished above are correct and complete.
          </p>
          <br>
          <table style="border: none;">
            <tr>
              <td style="border: none; width: 50%;">Place: __________________</td>
              <td style="border: none; width: 50%;">Signature of person responsible for deducting tax at source __________________</td>
            </tr>
            <tr>
              <td style="border: none;">Date: __________________</td>
              <td style="border: none;">Name and designation of person responsible for deducting tax at source <br><strong>${responsiblePersonName} (${responsiblePersonDesignation})</strong></td>
            </tr>
          </table>

          <!-- NOTES -->
          <div style="font-size: 8px; margin-top: 20px; color: #555;">
            Note :- (1) Indicate the type of deductor "Government"/"Others"<br>
            (2) Government deductors to give particulars of transfer vouchers; other deductors to give particulars of challan no. regarding deposit into bank.<br>
            (6) Please record on every page the totals of each of the columns.
          </div>

          <!-- ANNEXURE I -->
          <div class="page-break"></div>
          <div class="annexure-title">Annexure I - Deductee wise break-up of TDS</div>
          <div class="center" style="font-style: italic; font-size: 9px; margin-bottom: 10px;">(Please use separate Annexure for each line - item in the table at S.No. 04 of main Form 24Q)</div>
          
          <table style="border: 1px solid black; margin-bottom: 15px;">
             <tr>
               <td width="20%">BSR code of branch</td>
               <td width="30%">-</td>
               <td width="20%">Name of Employer</td>
               <td width="30%">${verifierName}</td>
             </tr>
             <tr>
               <td>Date Tax Deposited</td>
               <td>-</td>
               <td>TAN</td>
               <td>${tan}</td>
             </tr>
             <tr>
               <td>Challan Serial No.</td>
               <td>-</td>
               <td>Total TDS Allocated</td>
               <td>${totalDeducteeAmount}</td>
             </tr>
          </table>

          <table style="font-size: 8px;">
            <thead>
              <tr class="center" style="background-color: #f9f9f9;">
                <th>Sr.</th>
                <th>Emp Ref No</th>
                <th>PAN</th>
                <th>Name</th>
                <th>Payment Date</th>
                <th>Taxable Amt</th>
                <th>TDS</th>
                <th>Surcharge</th>
                <th>Cess</th>
                <th>Total TDS</th>
                <th>Deposited</th>
                <th>Deduction Date</th>
                <th>Deposit Date</th>
                <th>Reason*</th>
              </tr>
            </thead>
            <tbody>
              ${deductees
                .map(
                  (d, i) => `
                <tr>
                  <td class="center">${i + 1}</td>
                  <td>${d.employeeId || ''}</td>
                  <td class="center">${d.pan}</td>
                  <td>${d.name}</td>
                  <td class="center">${d.paymentDate}</td>
                  <td class="right">${d.totalSalary}</td>
                  <td class="right">${d.tdsDeducted}</td>
                  <td class="right">0</td>
                  <td class="right">0</td>
                  <td class="right">${d.tdsDeducted}</td>
                  <td class="right">${d.tdsDeducted}</td>
                  <td class="center">${d.paymentDate}</td>
                  <td class="center">${d.paymentDate}</td>
                  <td></td>
                </tr>
              `
                )
                .join('')}
               <!-- Fillers -->
               ${
                 deductees.length === 0
                   ? `
                 <tr>
                  <td class="center">1</td>
                  <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                 </tr>
               `
                   : ''
               }
              <tr>
                <td colspan="6" class="right bold">Total</td>
                <td class="right bold">${totalDeducteeAmount}</td> 
                <td></td>
                <td></td>
                <td class="right bold">${totalDeducteeAmount}</td>
                <td class="right bold">${totalDeducteeAmount}</td>
                <td colspan="3"></td>
              </tr>
            </tbody>
          </table>

          <!-- ANNEXURE II -->
          <div class="page-break"></div>
          <div class="annexure-title">ANNEXURE II</div>
          <div class="center" style="font-style: italic; font-size: 10px;">(Please use separate Annexure for each line - item in the table at S.No. 04 of main Form 24Q)</div>
          <p class="center" style="margin-top:5px;">Details of salary paid and tax deducted thereon from the employees</p>
           <table style="font-size: 9px;">
             <thead>
               <tr>
                 <th>Serial Number</th>
                 <th>Permanent Account Number(PAN) of the employee</th>
                 <th>Name of the employee</th>
                 <th>Date from which employed with current employer</th>
                 <th>Total amount of salary, excluding amount required to be shown in columns 332 and 333 (See note 4)</th>
                 <th>Total amount of house rent allowance and other allowances to the extent chargeable to tax [see section 10(13A) read with rule 2A and section 10(14)]</th>
                 <th>Value of perquisites and amount of accretion to Employee's Provident Fund Account-as per Annexure</th>
                 <th>Total of columns 331, 332 and 333.</th>
                 <th>Total deductions under section 16(i), 16(ii) and 16(iii) (specify each deduction separately)</th>
                 <th>Income chargeable under the head "Salaries" (Column 335 minus 336)</th>
                 <th>Income (including loss from house property) under any head other than Income under the head "Salaries" offered for TDS [Section 192(2B)]</th>
                 <th>Gross total income (Total of columns 337 and 338)</th>
                 <th>Amount deductible under section 80G in respect of donations to certain funds, charitable institutions.</th>
                 <th>Amount deductible under section 80GG in respect of rents paid</th>
                 <th>Amount deductible under any other provision of Chapter VI-A (indicate relevant section and amount deducted)</th>
                 <th>Total amount deductible under Chapter VI-A (Total of columns 340, 341 and 342)</th>
                 <th>Total taxable income (Column 339 minus column 343)</th>
                 <th>Income-tax on total income</th>
                 <th>Income tax rebate under section 88 on life insurance premium, contribution to provident fund etc. (See note 5)</th>
                 <th>Income Tax Rebate under section 88B</th>
                 <th>Income Tax Rebate under section 88C</th>
                 <th>Income Tax Rebate under section 88D</th>
                 <th>Total Income-tax payable (column 345 minus total of columns 346, 347, 348&349) and surcharge there on</th>
                 <th>Income tax relief under section 89, when salary etc. is paid in arrear or in advance</th>
                 <th>Net tax payable (column 350 minus column 351)</th>
               </tr>
                <tr class="center">
                <td>(327)</td><td>(328)</td><td>(329)</td><td>(330)</td><td>(331)</td><td>(332)</td><td>(333)</td><td>(334)</td><td>(335)</td><td>(336)</td>
                <td>(337)</td><td>(338)</td><td>(339)</td><td>(340)</td><td>(341)</td><td>(342)</td><td>(343)</td><td>(344)</td><td>(345)</td><td>(346)</td>
                <td>(347)</td><td>(348)</td><td>(349)</td><td>(350)</td><td>(351)</td><td>(352)</td>
              </tr>
             </thead>
              <tbody>
                <!-- Empty Placeholder rows as standard Annexure II is very detailed and might not have data in this simplified generator -->
                 ${[1, 2]
                   .map(
                     () => `
                   <tr style="height: 30px;">
                     <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                     <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                     <td></td><td></td><td></td><td></td><td></td><td></td>
                   </tr>
                 `
                   )
                   .join('')}
              </tbody>
           </table>

           <!-- ANNEXURE III -->
           <div class="page-break"></div>
           <div class="annexure-title">ANNEXURE III</div>
           <p class="center" style="margin-top:5px;">Particulars of value of perquisites and amount of accretion to Employee's Provident Fund Account for the year ending 31st March.......</p>
           <table style="font-size: 9px;">
             <thead>
               <tr>
                 <th>Name of Employee</th>
                 <th>Employee's Serial No. in Coloumn 327 of annexure II of Form No. 24Q.</th>
                 <th>Where accommodation is unfurnished</th>
                 <th>Value as if accommodation is unfurnished</th>
                 <th>Cost of furniture (including TV sets, radio sets, refrigerators, other household appliances and air-conditioning plant or equipment)</th>
                 <th>Perquisite value of furniture (10% of Column 357)</th>
                 <th>Total of Columns 356 and 358</th>
                 <th>Rent, if any, paid by the employee</th>
                 <th>Value of perquisite (Column 355 minus Column 360 or Column 359 minus Column 360, as may be applicable)</th>
                 <th>Where any conveyance has been provided by the employer free or at a concessional rate or where the employee is allowed the use of one or more motor-cars owned or hired by the employer or where the employer incurs the running expenses of a motor car owned by employees estimated value of perquisite(give details)</th>
                 <th>Remuneration paid by the employer for domestic and personal services provided to the employee (give details)</th>
                 <th>Value of free or concessional passages on home leave and other travelling to the extent chargeable to tax(give details)</th>
                 <th>Estimated value of any other benefit or amenity provided by the employer free of cost or at concessional rate not included in the preceding columns(give details)</th>
                 <th>Employer's contribution to recognized provident fund in excess of 12% of the employee's salary</th>
                 <th>Interest credited to the assessee's account in recognised provident fund in excess of the rate fixed by Central Government</th>
                 <th>Total of columns 361 to 367 carried to column 333 of Annexure-II of Form No. 24Q.</th>
               </tr>
                <tr class="center">
                <td>(353)</td><td>(354)</td><td>(355)</td><td>(356)</td><td>(357)</td><td>(358)</td><td>(359)</td><td>(360)</td><td>(361)</td><td>(362)</td>
                <td>(363)</td><td>(364)</td><td>(365)</td><td>(366)</td><td>(367)</td><td>(368)</td>
              </tr>
             </thead>
             <tbody>
                <!-- Empty Placeholder rows -->
                 ${[1, 2]
                   .map(
                     () => `
                   <tr style="height: 30px;">
                     <td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                     <td></td><td></td><td></td><td></td><td></td><td></td>
                   </tr>
                 `
                   )
                   .join('')}
             </tbody>
           </table>
           
           <div style="margin-top:20px;">
           <table style="border: none;">
            <tr>
              <td style="border: none; width: 50%;">Place: __________________</td>
              <td style="border: none; width: 50%;"></td>
            </tr>
            <tr>
              <td style="border: none;">Date: __________________</td>
               <td style="border: none;">
                 Name and signature of employer/person responsible for paying salary<br><br>
                 Designation.....................
               </td>
            </tr>
          </table>
          </div>

        </div>
      </body>
      </html>
    `
}
